import React from 'react';
import { ComboBox } from '@carbon/react';

export default function DropdownComboBoxControl(props) {
  return <ComboBox {...props} />;
}
